import React, { useState, useEffect, useCallback } from 'react'
import { Button, Card, CardBody, Col, Input, Row, Table } from 'reactstrap'
import { fetchData, _fetchApi } from '../api'
import Gray from '../Gray'
import { useSearchParams, useNavigate } from 'react-router-dom'
import UserGuide from '../UserGuide'
import { LoadingComponent } from '.'
import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'

export function ExcelDownload({ raw = [], fileName = 'ExportedData', className=null }) {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const fileExtension = '.xlsx'

  const exportToCSV = () => {
    const ws = XLSX.utils.json_to_sheet(raw)
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(data, fileName + fileExtension)
  }

  return (
    <Button className={className ? className : "m-2"} color="success" onClick={() => exportToCSV()}>
      Download in Excel
    </Button>
  )
}

function IndicatorBreakdown() {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const indicator = searchParams.get('indicator')
  const country = searchParams.get('country')
  const year_from = searchParams.get('year_from')
  const year_to = searchParams.get('year_to')
  const region = searchParams.get('region')
  const type_of_data = searchParams.get('type_of_data')
  const new_indicator = searchParams.get('new_indicator')
  const [countryList, setCountryLust] = useState([])
  const [indicatorList, setIndicatorList] = useState([])
  const [yearList, setYearList] = useState([])
  const [loading, setLoading] = useState(false)

  const in_years =
    year_from === year_to ? 1 : parseInt(year_to) - parseInt(year_from)

  const [form, setForm] = useState({
    year_from,
    year_to,
    new_year_from: year_from,
    new_year_to: year_to,
    indicator,
    country,
    region,
    type_of_data,
    new_indicator,
  })

  const [data, setData] = useState([])

  const getTotalByIndicator = useCallback(() => {
    setLoading(true)
    _fetchApi(
      `/get_by_indicator?query_type=total_by_indicator&year_from=${form.year_from}&year_to=${form.year_to}&indicator=${form.indicator}&in_years=${in_years}&type_of_data=Sub-Saharan Africa Regional Economic Outlook?(AFRREO)`,
      (d) => {
        setLoading(false)
        setData(d.results)
        console.log(d)
      },
      (err) => {
        setLoading(false)
        console.log(err)
      },
    )
  }, [form.year_from, form.year_to, form.indicator, in_years])

  useEffect(() => {
    getTotalByIndicator()
  }, [getTotalByIndicator])

  const getQueryParams = (key, value) => {
    setForm((p) => ({ ...p, [key]: value }))
    // let oldParams = {
    //   indicator,
    //   country,
    //   year_from,
    //   year_to,
    //   region,
    //   type_of_data,
    //   new_indicator,
    // }
    // let params = [
    //   'indicator',
    //   'country',
    //   'year_from',
    //   'year_to',
    //   'region',
    //   'type_of_data',
    //   'new_indicator',
    // ]
    // const newParams = {}
    // params.forEach((i) => {
    //   if (i !== key) {
    //     newParams[i] = oldParams[i]
    //   } else {
    //     newParams[key] = value
    //   }
    // })
    // return newParams
  }

  const handleChange = ({ target: { name, value } }) =>
    getQueryParams(name, value)

  const stageOne = true
  const display = true

  useEffect(() => {
    fetchData({ query_type: 'get_countries' })
      .then((d) => {
        if (d && d.results && d.results.length) {
          setCountryLust([
            'Regional Outlook',
            ...d.results.map((a) => a.country),
          ])
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }, [])

  useEffect(() => {
    fetchData({ query_type: 'get_indicators', type_of_data: form.type_of_data })
      .then((d) => {
        // console.log(d.results)
        if (d && d.results && d.results.length) {
          setIndicatorList([
            // 'Regional Indicator',
            ...d.results.map((a) => a.indicator),
          ])
          //   setForm((p) => ({ ...p, new_indicator: [d.results[0].indicator] }));4
          setForm((p) => ({
            ...p,
            year_from: "2004",
            year_to: "2022",
            country: "Regional Outlook",
            region: "wSub-Saharan Africa",
            type_of_data: "World Economic Outlook",
            indicator: d.results[0].indicator,
            new_indicator: d.results[0].indicator,
          }));
          //   setSearchParams(getQueryParams('indicator', d.results[0].indicator));
          //   setSearchParams(getQueryParams('new_indicator', d.results[0].indicator));
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }, [form.type_of_data])

  useEffect(() => {
    fetchData({
      query_type: 'get_years',
    })
      .then((d) => {
        if (d && d.results && d.results.length) {
          // console.log(d.results[d.results.length - 1].year, 'from')
          // console.log(d.results[0].year, 'to')
          setYearList(d.results.map((a) => a.year))
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }, [])

  return (
    <>
      <div className="d-flex flex-direction-row justify-content-between align-items-center">
        <Button
          size="sm"
          onClick={() => navigate(-1)}
          color="warning"
          className=""
        >
          Go back
        </Button> 
        {/* <Button
          // onClick={() => getRegionalAverage()}
        //   onClick={() => setDisplay(false)}
        //   color={!display ? "primary" : "secondary"}
          className="m-2"
        >
          Regional Average
        </Button>
        <Button
          className="m-2"
        //   color={display ? "primary" : "secondary"}
        //   onClick={() => setDisplay(true)}
        >
          Weighted Average
        </Button> */}
        <ExcelDownload
          raw={data}
          fileName={`Sub-Saharan Africa Regional Economic Outlook?(AFRREO) regional Average per indicator - ${country} (${year_from} - ${year_to})`}
        />
      </div>
      <Row>
        <Col md={9}>
          <CardBody>
            <Row>
              <Col md={6}>
                <>
                  <label className="text-white">Select Indicator</label>
                  <Input
                    type="select"
                    value={form.indicator}
                    name="indicator"
                    onChange={({ target: { value } }) => {
                      getQueryParams('indicator', value)
                      // setSearchParams({indicator: [value]})
                    }}
                  >
                    <option>--select--</option>
                    {indicatorList.map((indicator, id) => (
                      <option key={id} value={indicator}>
                        {indicator}
                      </option>
                    ))}
                  </Input>
                </>
              </Col>
              <Col md={6}>
                <>
                  <label className="text-white">Select Country</label>
                  <Input
                    type="select"
                    value={form.country}
                    name="country"
                    onChange={handleChange}
                  >
                    <option>--select--</option>
                    {countryList.map((country, id) => (
                      <option key={id} value={country}>
                        {country}
                      </option>
                    ))}
                  </Input>
                </>
              </Col>
            </Row>
          </CardBody>

          {/* {JSON.stringify(isWorldOutlook)} */}
          <div>
            <div>
              <Card className="p-3 mt-3">
                <h3 className="text-center">
                  Sub-Saharan Africa Regional Economic Outlook?(AFRREO) regional Average per indicator -{' '}
                  {country} ({year_from} - {year_to})
                </h3>

                {/* <Gray report={report} indicator={indicator} /> */}
                {loading && <LoadingComponent />}

                <div>
                  <Table bordered striped>
                    <thead>
                      <tr>
                        <th>Indicator</th>
                        {/* <th className="text-center">Weighted Average</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((d, i) => (
                        <tr key={i}>
                          <td
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              navigate(
                                `/world-outlook/countries-by-indicator?indicator=${d.indicator}&country=${country}&region=${region}&year_from=${year_from}&year_to=${year_to}&type_of_data=${type_of_data}&new_indicator=${new_indicator}`,
                              )
                            }}
                          >
                            {d.indicator}
                          </td>
                          {/* <td className="text-end">
                            {((d.amt * 100) / 100).toFixed(4)}
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card>
              {/* <Card
                body
                className="p-3 mt-3"
                style={{ height: '70vh', overflow: 'auto' }}
              >
                <Gray
                  report={data.map((a) => ({
                    ...a,
                    indicator: `${a['indicator'].slice(0, 5)}...`,
                  }))}
                  xDataKey="indicator"
                  yDataKey="amt"
                  // report={country[0] === "Regional Outlook" ? data : newArr}
                  indicator={[indicator]}
                  xAngle={-45}
                  //   stageOne={stageOne}
                />
              </Card> */}
            </div>
          </div>
        </Col>
        <Col md={3}>
          {/* <small>{JSON.stringify(stageTwo && isWorldOutlook)}</small> */}
          <label className="text-white">Date range</label>
          <Row className="mb-3">
            <Col md={6} className="m-0 pe-1">
              <Input
                type="select"
                value={form.year_from}
                name="year_from"
                onChange={handleChange}
              >
                <option>--select--</option>
                {yearList.map((indicator, id) => (
                  <option key={id} value={indicator}>
                    {indicator}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={6} className="m-0 ps-1">
              <Input
                type="select"
                value={form.year_to}
                name="year_to"
                onChange={handleChange}
              >
                {' '}
                <option>--select--</option>
                {yearList.map((indicator, id) => (
                  <option key={id} value={indicator}>
                    {indicator}
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
          <UserGuide stage={1} />
          {/* <SideBar
            form={indicatorByCountry}
            setForm={setForm}
            yearList={yearList}
            handleChange={handleChange}
            rawData={data}
            stageOne={stageOne}
            newArr={newArr}
            setStage={setStage}
            stage={stage}
          /> */}
        </Col>
      </Row>
    </>
  )
}

export default IndicatorBreakdown
